import StarsIconSvg from "../icons/stars.svg";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";

export const sendToggleInteractivityEvent = (e?: React.MouseEvent) => {
  e?.stopPropagation();
  document.dispatchEvent(new CustomEvent("toggleVote"));
};

const VotingButton = ({ interactive }: { interactive: boolean }) => {
  const translations = useTranslations();

  return (
    <PlayerControlButtonComponent
      aria-keyshortcuts={"i"}
      aria-label={translations("player__a11y__voice_over_open_voting_button")}
      onClick={sendToggleInteractivityEvent}
      tabIndex={interactive ? 0 : -1}
      Icon={<StarsIconSvg />}
      interactive
      hoverText={translations("player__a11y__hover_label_voting_button")}
    />
  );
};

export { VotingButton };
